const AppFonts = {
  OverpassBold: "OverpassBold",
  OverpassMedium: "OverpassMedium",
  OverpassRegular: "OverpassRegular",
  OverpassSemiBold: "OverpassSemiBold",
};
export default AppFonts;
